export const stats = () => {
    const $ = jQuery;

    const stats_wrappers = $('.voderman .stats-wrapper');

    if (stats_wrappers.length === 0) {
        return true;
    }

    $.each(stats_wrappers, (i, wrapper) => {
        const stats = $(wrapper).children();

        const intervalCallback = () => {
            for(let i = 0; i < stats.length; i++) {
                setTimeout(() => {
                    $(stats[i]).toggleClass('flipped');
                }, i * 800);
            }
        };

        let statsInterval = setInterval(intervalCallback, 5000);

        const handleStatClick = (e) => {
            $(e.currentTarget).toggleClass('flipped');
            clearInterval(statsInterval);

            statsInterval = setInterval(intervalCallback, 5000);
        }

        $(stats).on('click', handleStatClick);
    });
};